(ns assemble.resource.asset-tree
  (:require [assemble.component.new-folder :as new-folder]
            [common.db.context]
            [lemonpi.domain.interface.asset :as asset]
            [mate.re-frame :as mr]
            [re-frame.core :as rf]))

(rf/reg-event-fx :assemble.resource.asset-tree/list-folders
  [(rf/inject-cofx :sub [:context/advertiser-id])]
  (fn [{:keys [context/advertiser-id]} _]
    {:fx [[:cqrs/send {:type :asset/list-folders
                       :data {:asset-tree/parent-id asset/root-asset-id
                              :asset-tree/advertiser-id advertiser-id}}]]}))

(rf/reg-event-fx ::created-folder
  (fn [{:keys [db]} [_ advertiser-id]]
    (-> (new-folder/close-new-folder-modal {:db db})
        ;; No need to expand folder in tree here, because in current
        ;; implementation current folder (parent) is already expanded by
        ;; default.
        (mr/conj-fx [:cqrs/send {:type :asset/list-folders
                                 :data {:asset-tree/parent-id 1
                                        :asset-tree/advertiser-id advertiser-id}}]))))

(rf/reg-event-fx :assemble.resource.asset-tree/create-folder
  [(rf/inject-cofx :sub [:context/advertiser-id])]
  (fn [{:keys [context/advertiser-id]} [_ {:keys [parent-id folder-name]}]]
    {:fx [[:cqrs/send {:type :asset/create-folder
                       :path [:assemble.assets-page.db/new-folder :command]
                       :data {:asset-tree/name folder-name
                              :asset-tree/parent-id parent-id
                              :asset-tree/advertiser-id advertiser-id}
                       :then [::created-folder advertiser-id]}]]}))
